// Updated CompartmentEditor.js to support fixed 6 columns per row but editable column count (products) per row
import React, { useEffect, useState } from 'react';
import {
  Grid, Typography, Box, TextField, IconButton, Button, MenuItem
} from '@mui/material';
import { Delete } from '@mui/icons-material';

const MAX_COLS = 6;

const CompartmentEditor = ({
  initialLayout = [],
  initialMaxCol = MAX_COLS,
  onLayoutChange = () => {}
}) => {
  const [layout, setLayout] = useState(initialLayout);
  const [maxCol, setMaxCol] = useState(initialMaxCol);

  useEffect(() => {
    if (!initialLayout?.length) {
      const defaultLayout = Array(6).fill(null).map(() => ({ product: Array(6).fill({ qty: 0 }) }));
      setLayout(defaultLayout);
      onLayoutChange({ layout: defaultLayout, max_col: initialMaxCol });
    }
  }, [initialLayout, initialMaxCol]);

  const handleQtyChange = (rowIdx, colIdx, value) => {
    const newLayout = [...layout];
    newLayout[rowIdx].product[colIdx].qty = parseInt(value) || 0;
    setLayout(newLayout);
    onLayoutChange({ layout: newLayout, max_col: maxCol });
  };

  const handleProductChange = (rowIdx, colCount) => {
    const newLayout = [...layout];
    const currentRow = newLayout[rowIdx];
    const oldCols = currentRow.product.length;
    if (colCount > oldCols) {
      for (let i = oldCols; i < colCount; i++) {
        currentRow.product.push({ qty: 0 });
      }
    } else {
      currentRow.product = currentRow.product.slice(0, colCount);
    }
    newLayout[rowIdx] = { ...currentRow };
    setLayout(newLayout);
    onLayoutChange({ layout: newLayout, max_col: maxCol });
  };

  const addRow = () => {
    const newLayout = [...layout, { product: Array(1).fill({ qty: 0 }) }];
    setLayout(newLayout);
    onLayoutChange({ layout: newLayout, max_col: maxCol });
  };

  const deleteRow = (index) => {
    const newLayout = [...layout];
    newLayout.splice(index, 1);
    setLayout(newLayout);
    onLayoutChange({ layout: newLayout, max_col: maxCol });
  };

  return (
    <Box>
      <Typography variant="subtitle1" gutterBottom>
        Vending Grid Layout (Fixed 6-column view per row, but editable active compartments)
      </Typography>

      {layout.map((row, rowIndex) => (
        <Box key={rowIndex} sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Typography sx={{ mr: 2 }}>Row {rowIndex + 1}</Typography>
            <TextField
              select
              size="small"
              label="Columns"
              value={row.product.length}
              onChange={e => handleProductChange(rowIndex, parseInt(e.target.value))}
              sx={{ width: 100, mr: 2 }}
            >
              {[1, 2, 3, 4, 5, 6].map(n => (
                <MenuItem key={n} value={n}>{n}</MenuItem>
              ))}
            </TextField>
            <IconButton onClick={() => deleteRow(rowIndex)}><Delete /></IconButton>
          </Box>

          <Grid container spacing={1}>
            {[...Array(MAX_COLS)].map((_, colIdx) => (
              <Grid item xs={2} key={colIdx}>
                {colIdx < row.product.length ? (
                  <Box sx={{ border: '1px solid #ccc', p: 1, borderRadius: 1 }}>
                    <Typography variant="body2" align="center" gutterBottom>
                      R{rowIndex + 1}C{colIdx + 1}
                    </Typography>
                    <TextField
                      label="Max Qty"
                      type="number"
                      fullWidth
                      size="small"
                      value={row.product[colIdx].qty}
                      onChange={e => handleQtyChange(rowIndex, colIdx, e.target.value)}
                    />
                  </Box>
                ) : (
                  <Box sx={{ border: '1px dashed #ccc', p: 1, borderRadius: 1, height: '100%' }}>
                    <Typography variant="body2" align="center" color="text.secondary">
                      Empty
                    </Typography>
                  </Box>
                )}
              </Grid>
            ))}
          </Grid>
        </Box>
      ))}

      <Box sx={{ mt: 2 }}>
        <Button onClick={addRow} variant="outlined">Add Row</Button>
      </Box>
    </Box>
  );
};

export default CompartmentEditor;


// import React, { useState, useEffect } from 'react';
// import {
//   Box, Typography, Grid, TextField, MenuItem
// } from '@mui/material';

// const CompartmentEditor = ({ initialLayout = [], initialMaxCol = 6, onLayoutChange }) => {
//   const [rowCount, setRowCount] = useState(initialLayout.length || 6);
//   const [colCount, setColCount] = useState(initialMaxCol || 6);
//   const [layout, setLayout] = useState([]);

//   useEffect(() => {
//     if (initialLayout.length > 0) {
//       setLayout(initialLayout);
//     } else {
//       generateLayout(rowCount, colCount);
//     }
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, []);

//   useEffect(() => {
//     generateLayout(rowCount, colCount);
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [rowCount, colCount]);

//   const generateLayout = (rows, cols) => {
//     const newLayout = Array.from({ length: rows }, (_, rowIdx) => ({
//       product: Array.from({ length: cols }, (_, colIdx) => ({
//         qty:
//           layout?.[rowIdx]?.product?.[colIdx]?.qty ??
//           0
//       }))
//     }));
//     setLayout(newLayout);
//     onLayoutChange({ layout: newLayout, max_col: cols });
//   };

//   const handleQtyChange = (rowIdx, colIdx, value) => {
//     const updated = [...layout];
//     updated[rowIdx].product[colIdx].qty = parseInt(value, 10) || 0;
//     setLayout(updated);
//     onLayoutChange({ layout: updated, max_col: colCount });
//   };

//   return (
//     <Box>
//       <Box display="flex" gap={2} mb={2}>
//         <TextField
//           select
//           label="Rows"
//           value={rowCount}
//           onChange={(e) => setRowCount(parseInt(e.target.value, 10))}
//           size="small"
//         >
//           {[...Array(12)].map((_, i) => (
//             <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
//           ))}
//         </TextField>
//         <TextField
//           select
//           label="Columns"
//           value={colCount}
//           onChange={(e) => setColCount(parseInt(e.target.value, 10))}
//           size="small"
//         >
//           {[...Array(12)].map((_, i) => (
//             <MenuItem key={i + 1} value={i + 1}>{i + 1}</MenuItem>
//           ))}
//         </TextField>
//       </Box>

//       <Box>
//         {layout.map((row, rowIdx) => (
//           <Grid container spacing={1} key={rowIdx} mb={1}>
//             {row.product.map((comp, colIdx) => (
//               <Grid item xs={12 / colCount} key={colIdx}>
//                 <Box
//                   sx={{
//                     border: '1px solid #ccc',
//                     borderRadius: 1,
//                     padding: 1,
//                     textAlign: 'center'
//                   }}
//                 >
//                   <Typography variant="caption" display="block">
//                     R{rowIdx + 1}C{colIdx + 1}
//                   </Typography>
//                   <TextField
//                     type="number"
//                     label="Qty"
//                     size="small"
//                     value={comp.qty}
//                     onChange={(e) => handleQtyChange(rowIdx, colIdx, e.target.value)}
//                     fullWidth
//                     inputProps={{ min: 0 }}
//                   />
//                 </Box>
//               </Grid>
//             ))}
//           </Grid>
//         ))}
//       </Box>
//     </Box>
//   );
// };

// export default CompartmentEditor;

